"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pievepelago": {
    "8e5c7cd5": [{
      "hkey": "70a40a12",
      "slug": "pievepelago",
      "name": "Pievepelago",
      "primary": true,
      "skipSearch": false
    }],
    "lago-santo-modenese": [{
      "hkey": "70a40a12",
      "slug": "pievepelago",
      "name": "Pievepelago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7fb0d3ec": [{
      "hkey": "70a40a12",
      "slug": "pievepelago",
      "name": "Pievepelago",
      "primary": true,
      "skipSearch": false
    }],
    "rovaceto": [{
      "hkey": "70a40a12",
      "slug": "pievepelago",
      "name": "Pievepelago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7351caf9": [{
      "hkey": "31b1aca0",
      "slug": "sant-annapelago",
      "name": "Sant'Annapelago",
      "primary": true,
      "skipSearch": false
    }],
    "sant-anna-pelago": [{
      "hkey": "31b1aca0",
      "slug": "sant-annapelago",
      "name": "Sant'Annapelago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b02e5b96": [{
      "hkey": "f0b389ba",
      "slug": "casoni-piangrande",
      "name": "Casoni-Piangrande",
      "primary": true,
      "skipSearch": false
    }],
    "casoni": [{
      "hkey": "f0b389ba",
      "slug": "casoni-piangrande",
      "name": "Casoni-Piangrande",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;